import React, { useContext, useEffect, useState } from "react";
import RecordingContext from "../../context/RecordingContext";
import { eventBus } from "../../utils/eventBus";
import { isPractice9928 } from "../../config/practice";
import { isLiveTodayVisit } from "../../utils/visitGuard";
import { normalizeApptId } from "../../utils/recordingCompletion";
import { v2StoreKey } from "../../landingscreen/patientcharts/tabs/careiq/N3/orderV2";
import { liveCardOnFor } from "./liveOrdersModel";
import LiveOrdersCard from "./LiveOrdersCard";

/* The live Orders card where providers actually enter orders (hubfix-oi-1026, owner 10-26; live 10-26: 79 rows on
   the chart's LiveScribe panel, 0 taps, the same orders typed by hand a median 3.6 min later).

   surface "orders"    the Orders popup / page (src/orders/orders.jsx), for the visit it is open on
   surface "dashboard" the dashboard's expanded patient card, for that row's visit

   A thin gate: the full LiveOrdersCard (same model, placement path, wrong-patient / visit binding, in-flight guard,
   Today / Schedule) mounts only when ALL hold - practice 9928 (OSA unchanged), the visit is today's and held, and
   BlinkScribe enabled the live card for exactly this patient + appointment (the recording socket's block, or the
   block stored after the stop). Which providers get it is still BlinkScribe's live_orders.enabled (the same users as
   the chart's card). Everyone else: nothing renders and no hook of the card runs. */

const storedBlockFor = (pid, appt) => {
  if (!pid || !appt) return null;
  try {
    const raw = localStorage.getItem(v2StoreKey(pid, appt));
    if (!raw) return null;
    const st = JSON.parse(raw);
    return st && st.payload && st.payload.live_orders ? st.payload.live_orders : null;
  } catch (_) {
    return null;
  }
};

export const liveSlotOn = (socketLive, patientId, chart) => {
  if (!isPractice9928() || !chart || !isLiveTodayVisit(chart)) return false;
  const pid = patientId != null ? String(patientId) : "";
  const appt = normalizeApptId(chart.appointmentid);
  if (!pid || !appt) return false;
  return liveCardOnFor(socketLive, pid, chart) || liveCardOnFor(storedBlockFor(pid, String(appt)), pid, chart);
};

// a test mock (or a build) without the context object: read a null context instead of useContext(undefined)
const NO_CONTEXT = React.createContext(null);

const LiveOrdersSlot = ({ patientId, chart, surface }) => {
  // null-safe (useRecording throws outside a RecordingProvider): no provider = nothing renders
  const rc = useContext(RecordingContext || NO_CONTEXT);
  const liveOrders = rc ? rc.liveOrders : null;
  const [, setTick] = useState(0);
  useEffect(() => {
    const on = () => setTick((n) => n + 1);
    eventBus.on("liveOrdersStored", on);
    return () => eventBus.off("liveOrdersStored", on);
  }, []);
  if (!rc || !liveSlotOn(liveOrders, patientId, chart)) return null;
  return <LiveOrdersCard patientId={patientId} chart={chart} surface={surface} />;
};

export default LiveOrdersSlot;
